import { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers';
import { getServicos } from 'volto-ministerio-publico-federal/actions/servicos';
import type { ServicosState } from 'volto-ministerio-publico-federal/reducers/servicos';
import type { ServicosCategoria } from 'volto-ministerio-publico-federal/helpers/Servicos';

interface UseServicosResult {
  categorias: ServicosCategoria[];
  loaded: boolean;
  loading: boolean;
  error: unknown;
}

export function useServicos(pastaUrl?: string): UseServicosResult {
  const dispatch = useDispatch();
  const pastaPath = pastaUrl ? flattenToAppURL(pastaUrl) : '';
  const estado = useSelector((state: { servicos?: ServicosState }) =>
    pastaPath ? state.servicos?.[pastaPath] : undefined,
  );
  const store = useStore<{ servicos?: ServicosState }>();

  useEffect(() => {
    if (!pastaPath) return;
    const atual = store.getState().servicos?.[pastaPath];
    if (!atual?.loading && !atual?.loaded) {
      dispatch(getServicos(pastaPath));
    }
  }, [dispatch, store, pastaPath]);

  return {
    categorias: estado?.categorias ?? [],
    loaded: Boolean(estado?.loaded),
    loading: Boolean(estado?.loading),
    error: estado?.error ?? null,
  };
}

export default useServicos;
